module.exports = __webpack_public_path__ + "img/70.7393c261.jpg";